import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/web.dom-collections.iterator";
/**
 * Section: Example
 * ------------------------------------------------------------------------------
 * Example section configuration for complete theme support.
 * - https://github.com/Shopify/theme-scripts/tree/master/packages/theme-sections.
 *
 * @namespace example
 */

import { register } from '@shopify/theme-sections';
import Carousel from '~/components/carousel';
import { on } from '~/helpers/utils';
import cssClasses from '~/helpers/cssClasses';
/**
 * DOM selectors.
 */

const selectors = {
  id: 'Careers',
  toggleContainer: '[js-careers="toggleContainer"]',
  toggleButton: '[js-careers="toggleButton"]',
  toggleSection: '[js-careers="toggleSection"]'
};
let toggleCarousel = {};
/**
 * Register the `example-section` section type.
 */

register('careers', {
  /**
   * Custom public section method.
   */
  cacheSelectors() {
    const container = "#".concat(selectors.id, "-").concat(this.id);
    const toggleContainer = "".concat(container, " ").concat(selectors.toggleContainer);
    const toggleButton = "".concat(container, " ").concat(selectors.toggleButton);
    const toggleSection = "".concat(container, " ").concat(selectors.toggleSection);
    this.nodeSelectors = {
      container,
      toggleContainer,
      toggleButton,
      toggleSection
    };
  },

  /**
   * Set cached node selectors.
   */
  setNodeSelectors() {
    this.toggleContainer = document.querySelector(this.nodeSelectors.toggleContainer);
    this.toggleButton = document.querySelectorAll(this.nodeSelectors.toggleButton);
    this.toggleSection = document.querySelectorAll(this.nodeSelectors.toggleSection);
  },

  /**
   * Construct carousel.
   */
  constructCarousel() {
    toggleCarousel = Carousel(this.nodeSelectors.toggleContainer, {
      swiper: {
        centeredSlides: false,
        slidesPerView: 'auto',
        loop: false,
        freeMode: true,
        scrollbar: {
          draggable: true,
          el: '.swiper-scrollbar',
          hide: true,
          snapOnRelease: false
        }
      }
    });
    toggleCarousel.init();
  },

  setEventBusListeners() {
    Frame.EventBus.listen("Carousel-".concat(this.nodeSelectors.toggleContainer, ":settle"), () => {
      toggleCarousel.slides.css('width', '');
    });
  },

  /**
   * Callback function when section is loaded via `sections.load()` or
   * by the Theme Editor `shopify:section:load` event.
   */
  onLoad() {
    // Do something when a section instance is loaded
    this.cacheSelectors();
    this.setNodeSelectors();

    if (this.toggleButton.length > 0) {
      this.setEventListeners();
      this.constructCarousel();
    }
  },

  /**
   * Set section event listeners.
   */
  setEventListeners() {
    [...this.toggleButton].forEach(button => {
      on('click', button, event => this.toggleButtonHandler(event));
    });
  },

  /**
   * Toggle button click event handler.
   * @param {Event} event - Toggle button click event.
   */
  toggleButtonHandler(event) {
    const {
      currentTarget
    } = event;
    const {
      toggle
    } = currentTarget.dataset;

    if (toggle === 'all') {
      this.resetToggleSections(currentTarget);
      return;
    }

    currentTarget.classList.add(cssClasses.active);
    this.setActiveToggleSection(currentTarget);
  },

  /**
   * Toggle active sections handler.
   * @param {HTMLElement} currentTarget - Clicked toggle button.
   */
  setActiveToggleSection(currentTarget) {
    [...this.toggleButton].forEach(element => {
      const {
        toggle
      } = element.dataset;

      if (toggle === 'all') {
        element.classList.remove(cssClasses.active);
        return;
      }

      const toggleContainer = [...this.toggleSection].find(container => container.dataset.toggle === toggle);

      if (element === currentTarget) {
        toggleContainer.classList.remove(cssClasses.hidden);
      } else {
        element.classList.remove(cssClasses.active);
        toggleContainer.classList.add(cssClasses.hidden);
      }
    });
  },

  /**
   * Sets all sections to visible.
   * @param {HTMLElement} currentTarget - Current toggle button.
   */
  resetToggleSections(currentTarget) {
    currentTarget.classList.add(cssClasses.active);
    [...this.toggleButton].forEach(element => {
      if (element !== currentTarget) {
        element.classList.remove(cssClasses.active);
      }
    });
    [...this.toggleSection].forEach(element => {
      element.classList.remove(cssClasses.hidden);
    });
  }

});